import React from "react";
import { MinusCircleOutlined } from "@ant-design/icons";
import { Col, Row, Form, Tooltip, Select, Button } from "antd";

const LanguageFields = ({ remove, id, form, languages, initialValues, readonly=false }) => {
  const { getFieldDecorator } = form
  return (
    <>
      <Row>
        <Col xs={{ span: 12 }}>
          <Form.Item
            label={`Seleccione un idioma`}
          >
            {getFieldDecorator(`language[${id}]`, {
              initialValue: initialValues?.id,
              rules: [{required: true, message: "El campo es requerido."}]
            })(
                <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Tipo de pregunta"
                disabled={readonly == true}
                >
                {languages.map((item) => (
                    <Select.Option key={item.id} value={item.id} label={`${item.description}` || ""}>{item.description}</Select.Option>
                ))}
                </Select>
            )}
          </Form.Item>
        </Col>
        <Col style={{top: 60}} xs={{ span: 1, offset: 11 }}>
              <Tooltip title="Quitar opción">
                  <Button className="delete-button" icon="delete" disabled={readonly == true} onClick={() => remove(id)} />
              </Tooltip>
        </Col>
      </Row>
    </>
  );
};

export default LanguageFields;
